import { Skeleton } from '@treezor/design-system';

export interface ITableSkeleton {
  columns?: number;
  rows?: number;
}

export function TableSkeleton({ columns = 10, rows = 6 }: ITableSkeleton) {
  return (
    <div className="flex w-full flex-col mb-2">
      <Skeleton className="w-full h-8" />
      {[...Array(rows)].map((_, index) => (
        <div className="flex w-full gap-2 mt-2" key={`skeleton-col-${index}`}>
          {[...Array(columns)].map((_, index) => (
            <div className="w-1/6" key={`skeleton-row-${index}`}>
              <Skeleton className="h-9 mt-1" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
